import { render, staticRenderFns } from "./Deal_customer.vue?vue&type=template&id=0ffa91d4&"
import script from "./Deal_customer.vue?vue&type=script&lang=js&"
export * from "./Deal_customer.vue?vue&type=script&lang=js&"
import style0 from "./Deal_customer.vue?vue&type=style&index=0&id=0ffa91d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports